import { Modal, Form, Input, Button } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { text } from "stream/consumers";

interface TagFormValues {
    name: string;
    description?: string;
}

interface TagModalProps {
    open: boolean;
    mode: "add" | "edit";
    initialValues?: TagFormValues;
    onCancel: () => void;
    onSubmit: (values: TagFormValues) => void;
    loading?: boolean;
}

export default function AddModal({
    open,
    mode,
    initialValues,
    onCancel,
    onSubmit,
    loading,
}: TagModalProps) {
    const [form] = Form.useForm();
    const { t } = useTranslation();

    useEffect(() => {
        if (open) {
            form.setFieldsValue(
                initialValues || {
                    name: "",
                    description: "",
                }
            );
        }
    }, [open, initialValues, form]);

    const handleFinish = (values: TagFormValues) => {
        onSubmit(values);
    };

    return (
        <Modal
            title={mode === "add" ? t('profession.modal_add') : t('profession.modal_edit')}
            open={open}
            onCancel={() => {
                form.resetFields();
                onCancel();
            }}
            footer={null}
            centered
            destroyOnClose
            className="dark:[&_.ant-modal-content]:bg-[#1f1f1f]
                dark:[&_.ant-modal-header]:bg-[#1f1f1f]
                dark:[&_.ant-modal-close]:text-white
                dark:[&_.ant-modal-title]:text-white"
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    label={<span className="t-text-white">{t('profession.name_label')}</span>}
                    name="name"
                    rules={[{ required: true, message: t('profession.name_required') }]}
                >
                    <Input className="dark:bg-[#141414] t-text-white dark:border-gray-600" />
                </Form.Item>

                <Form.Item
                    label={<span className="t-text-white">{t('profession.description')}</span>}
                    name="description"
                >
                    <Input.TextArea
                        rows={4}
                        className="dark:bg-[#141414] t-text-white dark:border-gray-600"
                    />
                </Form.Item>

                <div className="flex justify-end gap-2 pt-4 border-t dark:border-gray-700">
                    <Button onClick={onCancel}>{t('profession.cancel')}</Button>
                    <Button
                        htmlType="submit"
                        type="primary"
                        loading={loading}
                        className="!bg-[#3e91ab] hover:!bg-[#357f96] border-none"
                    >
                        OK
                    </Button>
                </div>
            </Form>
        </Modal>
    );
}